import React, { useState } from "react";
import { Typography, Button, TextField, Grid, Box } from "@mui/material";

const AccountDetails = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    // Handle form submission logic here
    console.log(formData);
  };

  return (
    <>
      <Typography variant="h5" gutterBottom>
        Account Details
      </Typography>

      {/* Form */}
      <Grid container spacing={3}>
        {/* Name Field */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Name
          </Typography>
          <TextField
            variant="outlined"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </Grid>

        {/* Email Field */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Email
          </Typography>
          <TextField
            variant="outlined"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
          />
        </Grid>

        {/* Current Password Field */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Current Password
          </Typography>
          <TextField
            variant="outlined"
            name="currentPassword"
            type="password"
            value={formData.currentPassword}
            onChange={handleChange}
          />
        </Grid>

        {/* New Password Field */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            New Password
          </Typography>
          <TextField
            variant="outlined"
            name="newPassword"
            type="password"
            value={formData.newPassword}
            onChange={handleChange}
          />
        </Grid>

        {/* Confirm New Password Field */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Confirm New Password
          </Typography>
          <TextField
            variant="outlined"
            name="confirmNewPassword"
            type="password"
            value={formData.confirmNewPassword}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <Box sx={{ marginTop: "20px" }}>
        <Button variant="outlined" color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Box>
    </>
  );
};

export default AccountDetails;
